export const USER_PERMISSIONS = {
  VIEW_ACCOUNT_LIST: "VIEW_ACCOUNT_LIST",
  VIEW_CAPTIO_CONCEPTS: "VIEW_CAPTIO_CONCEPTS",
  VIEW_VISUAL_PARTS: "VIEW_VISUAL_PARTS",
};
